import {useEffect, useState} from 'preact/hooks';

/**
 * Custom React hook to detect media query changes through JS.
 *
 * This is meant to be used only in extreme cases in which we need to switch states
 * without having to perform a full page refresh.
 *
 * @see {@link https://usehooks-ts.com/react-hook/use-media-query} for references.
 * */
const useMediaQuery = (query) => {
    const getMatches = (query) => {
        // Prevents SSR issues
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        
        return false
    }

    const [matches, setMatches] = useState(getMatches(query));

    function handleChange() {
        setMatches(getMatches(query));
    }

    useEffect(() => {
        const matchMedia = window.matchMedia(query);

        // Triggered at the first client-side load and if query changes
        handleChange();
        // Listen matchMedia
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        } else {
            matchMedia.addEventListener('change', handleChange);

            // console.log(matchMedia.addListener);
        }

        return () => {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            } else {
                matchMedia.removeEventListener('change', handleChange);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    return matches;
}

export default useMediaQuery;
